import React, { Component } from 'react';
import { TextField } from '@mui/material';
import BarcodeAndFind from './BarcodeAndFind.jsx';
import DateRangeFilter from '../../../common/DateRangeFilter';

class RequisitionsNewSearchbar extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    handleChange = (e) => {
        this.props.findSample(e);
    };

    render() {
        return (
            <div>
                <div className="row justify-content-start align-items-center" style={{ padding: '15px' }}>
                    <div className="col-md-4 col-sm-12 col-12 grid-buttons">
                        <TextField
                            style={{ width: '100%' }}
                            label="Search New Samples"
                            variant="outlined"
                            id="reset-form"
                            margin="dense"
                            onChange={this.props.onSearchTextChange}
                            value={this.props.searchString}
                        />
                    </div>
                    <div className="col-md-6 mb-3">
                        <div className="row">
                            <div className="col-md-12">
                                <DateRangeFilter
                                    date_range={this.props.date_range}
                                    from_date={this.props.from_date}
                                    to_date={this.props.to_date}
                                    updateDateRange={this.props.updateDateRange}
                                    handleDateFiltersChange={this.props.handleDateFiltersChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2 col-sm-12 col-12 grid-buttons">
                        <BarcodeAndFind sampleIds={this.props.sampleIds} handleChange={this.handleChange} />
                    </div>
                </div>
            </div>
        );
    }
}

export default RequisitionsNewSearchbar;
